module.exports = __webpack_public_path__ + "static/media/work-img2-3.043a2d24.png";